module.exports = __webpack_public_path__ + "static/pic14-63416ae0c2f4db90f430180495ee1998.png";